import { Agente } from './agente.class';
import { FiltroAgente } from '../filtro/filtro-agente';


export class Auxiliar extends Agente {


    constructor() {
        super();
    }

    public getDniAgente(): String {
        return this.informacionBasica.dni;
    }

    public getCodigoAgente(): String {
        return null;
    }

    public habilitarOpcionesAgente(): boolean {
        return true;
    }

    public getFiltroAgente(): FiltroAgente {
        const filtroAgente = new FiltroAgente();
        filtroAgente.codAsesor = this.informacionBasica.dni;
        filtroAgente.loginAsesor = this.informacionBasica.usuario;
        return filtroAgente;
    }
    public getRestriccionSeleccionAgente() {
        return '';
    }

    public isAsesor(): boolean {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/agente/auxiliar.class.ts